import type { PropsWithChildren } from "react";
import { MorphemeInfoPanelContext } from "#morpheme-info-panel-context";
import { useMorphemeInfoPanelContextValue } from "#morpheme-info-panel-context-value";

export function MorphemeInfoPanelContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useMorphemeInfoPanelContextValue>[0]>) {
  const value = useMorphemeInfoPanelContextValue(props);
  return (
    <MorphemeInfoPanelContext.Provider value={value}>{children}</MorphemeInfoPanelContext.Provider>
  );
}
